export const normalizeOemPdfPageImageUrl = (
  url: string,
  backendBaseUrl: string,
  currentHref: string = window.location.href,
): string | null => {
  try {
    const parsed = new URL(url, currentHref);
    if (
      !parsed.pathname.startsWith('/api/oem/pdf-page-image')
      && !parsed.pathname.startsWith('/api/oem/managed-pdf-page-image')
      && !parsed.pathname.startsWith('/api/oem/carrier-live-pdf-page-image')
    ) {
      return null;
    }

    return `${backendBaseUrl.replace(/\/$/, '')}${parsed.pathname}${parsed.search}`;
  } catch (_error) {
    return null;
  }
};

export const normalizeBackendAgentArtifactUrl = (
  url: string,
  backendBaseUrl: string,
  currentHref: string = window.location.href,
): string | null => {
  try {
    const parsed = new URL(url, currentHref);
    if (
      !parsed.pathname.startsWith('/api/job-photos/')
      && !parsed.pathname.startsWith('/api/generated-images/')
      && !parsed.pathname.startsWith('/api/work-orders/pdf')
    ) {
      return null;
    }

    return `${backendBaseUrl.replace(/\/$/, '')}${parsed.pathname}${parsed.search}`;
  } catch (_error) {
    return null;
  }
};
